let captured = null;

export function getAttribution() {
  if (captured) return captured;
  const p = new URLSearchParams(window.location.search);
  captured = {
    utm_source: p.get("utm_source") || "",
    utm_medium: p.get("utm_medium") || "",
    utm_campaign: p.get("utm_campaign") || "",
    utm_content: p.get("utm_content") || "",
    utm_term: p.get("utm_term") || "",
    fbclid: p.get("fbclid") || "",
    gclid: p.get("gclid") || "",
    pageUrl: window.location.href,
    referrer: document.referrer || "",
    timestamp: new Date().toISOString(),
  };
  return captured;
}

export function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -40 });
  else el.scrollIntoView({ behavior: "smooth" });
}
